"use strict";

document.addEventListener("DOMContentLoaded", function () {
  (function subscribeForm() {
    // const subscribeSections = document.querySelectorAll(
    //   ".omd-subscribe-section"
    // );
    // if (subscribeSections.length) {
    //   subscribeSections.forEach((item) => {
    //     const form = document.querySelector(".omd-subscribe-form");
    //     const formPopup = document.querySelector(".omd-subscribe-form-popup");
    //     const input = form.querySelector(".omd-subscribe-form__input");
    //     form.addEventListener("submit", (e) => {
    //       e.preventDefault();
    //       fetch(form.action, {
    //         method: "POST",
    //         headers: {
    //           Accept: "application/json",
    //           "Content-Type": "application/json",
    //         },
    //         body: {
    //           email: input.value,
    //         },
    //       }).then((res) => {
    //         if (res.ok) {
    //           form.classList.add("hidden");
    //           formPopup.classList.add("active");
    //           return res.json();
    //         }
    //       });
    //     });
    //   });
    // }
  })();
});